import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { InventoryPage } from "@/features/domain/components/inventory-page";
import { useI18n } from "@/providers/i18n-provider";

function InventoryRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Inventory`)}
      description={t(msg`Sign in to manage your church inventory.`)}
    >
      <PageContainer maxWidth="3xl">
        <InventoryPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const inventoryRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/inventory",
  component: InventoryRoutePage,
});
